<template>
    <div id="similar_media_list" class="yScroll">
        <vue-custom-scrollbar class="ps" :style='isMobileMode?"height:100%;":"max-height: 60vh;"'>
            <div class="item-images flex-images flexbin flexbin-margin" v-if="isDataLoading">
                <div class="item" v-for="n in 5" :key="n">
                    <span class="skeleton-box" style="width:100%;height:100%;">&nbsp;</span>
                </div>
            </div>
            <div class="item-images flex-images flexbin flexbin-margin" v-else>
                <div class="item"
                    v-for="media in similarList"
                    :key="media.id"
                >
                    <img
                        :src="media.thumbnail"
                        :alt="media.title+' 이미지 입니다.'"
                    >
                    <span class="source-origin">사진출처: {{media.copyright}}</span>
                    <div class="overlay">
                        <div class="point">{{media.media_type_name}}</div>
                        <a href="#//" :title="media.title" @click="$emit('select-media', media)">
                            <span class="text">{{media.title}}</span>
                            <span class="overlay-origin">({{media.copyright}})</span>
                        </a>
                    </div>
                </div>
            </div><!-- flex-images -->
        </vue-custom-scrollbar>
    </div>
</template>

<script>
import VueCustomScrollbar from 'vue-custom-scrollbar'; 

export default {
    components: {
        VueCustomScrollbar, // <vue-custom-scrollbar>
    },
    props: {
        similarList: { type: Array|Object, }, // 유사자료 목록
        isDataLoading: { type: Boolean }, // 데이터 통신중?
    },
    created(){
        const docWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        this.isMobileMode = docWidth<640;
        // console.log(docWidth, this.isMobileMode);
    },
}
</script>

<style lang="scss">
// Default variables that can be overrided
$flexbin-row-height: 165px !default;
$flexbin-space: 5px !default;

$flexbin-tablet-max: 980px !default;
$flexbin-row-height-tablet: 150px !default;
$flexbin-space-tablet: $flexbin-space !default;

$flexbin-phone-max: 400px !default;
$flexbin-row-height-phone: 100px !default;
$flexbin-space-phone: $flexbin-space !default;

// Minxin for customize multiple Flexbin layout
// For example, 300px height for desktop devices, 150px height for mobile devices
@mixin flexbin($row-height, $space) {
    display: flex;
    overflow: hidden;
    flex-wrap: wrap;
    margin: - $space / 2;

    // Let final row align left fit if images are not enough to fill
    // If the gap is very small, fill the final row
    &:after {
        content: '';
        flex-grow: 999999999; // avoid final row zoom too much to fit width
        min-width: $row-height; // avoid small gap in final row (< $row-height)
        height: 0;
    }

    > * {
        position: relative;
        display: block;
        height: $row-height;
        margin: $space / 2;
        flex-grow: 1;

        img {
            height: $row-height;
            object-fit: cover;
            max-width: 100%;
            min-width: 100%;
            vertical-align: bottom;
        }
    }


    // Add margin around flexbin gallery
    // Visual margin is the same with space between rows
    &.flexbin-margin {
        margin: $space / 2;
    }
}

// CSS class for basic usage
.flexbin {
    // Desktop devices
    @include flexbin($flexbin-row-height, $flexbin-space);

    // Tablet devices
    @media (max-width: $flexbin-tablet-max) {
        @include flexbin($flexbin-row-height-tablet, $flexbin-space-tablet);
    }

    // Phone devices
    @media (max-width: $flexbin-phone-max) {
        @include flexbin($flexbin-row-height-phone, $flexbin-space-phone);
    }
}
</style>